import './CodeHighlight.scss';

import classNames from 'classnames';
import { CodeItem } from './CodeItem';
import { CodeReference } from '@sonar-software/sonar-ts-types';
import React from 'react';

export interface CodeHighlightProps {
	code: string;
	codeReferences: Array<CodeReference>;
	index: number;
	isNested?: boolean;
}

export const CodeHighlight: React.FC<CodeHighlightProps> = ({ code, codeReferences, index, isNested }) => {
	if (!code) {
		return null;
	}

	const classes = classNames('code-highlight', {
		nested: isNested
	});

	const references = codeReferences.map((ref) => {
		const { sonarObjectId, sonarObjectType, startChar, endChar } = ref;

		const periscopeOptions = sonarObjectId ? {
			id: sonarObjectId,
			name: '',
			openedFromIndex: index,
			type: sonarObjectType
		} : undefined;

		return {
			end: endChar,
			periscopeOptions,
			start: startChar
		};
	});

	return (
		<div className={ classes }>
			<CodeItem
				code={ code }
				sections={ references } />
		</div>
	);
};
